import React,{useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import courseImg from "../../template/images/course.png";
const CourseItem = (props) => {
  const { title, author, duration, description, price, courseId, courseImg, course, isActiveOffer, offerName, offerEndDate, offerPrice, courseType } = props;
  console.log("iddd",courseId)

  const navigate = useNavigate();
  const[existingFlag, setExistingFlag] = useState('');

  useEffect(()=>{
      checkExisting();
  },[]);

  const checkExisting = () => {
    const userObj = JSON.parse(localStorage.getItem('userObj'))
    if(userObj.existingFlag == true){
        setExistingFlag(true);
    }else{
        setExistingFlag(false);
    }
}

  const handleSubscription = () => {
    navigate(`/subscription/${courseId}`);
  };

  // const handleKnowMore = () => {
  //   navigate(`/courseView/${courseId}`);
  // };
  const handleKnowMore = (e) => {
    e.preventDefault()
    navigate(`/courseView/${courseId}`)
    window.location.reload()
}

  const handleKnowMoreView = () => {
    navigate(`/popularCourseView/${courseId}`);
  };

  const handleTeamsRedirect = () => {
    navigate('/EnquiryForm?cataGory='+1+'&courseId='+courseId);
}

const handleBuyNow = () => {
  
      navigate(`/CreateAccount`)
    
 
}

  return (
    <React.Fragment>
      <div className="card course_card">
        <img
          src={courseImg}
          className="card-img-top course_image"
          alt="Course image"
        />
        <div className="card-body">
          <h5 className="card-title course_title">{title}</h5>
          <div className="authorsAndtime">
            {/* <p className="author_name">
              <span className="auth_icon">
                <i className="fa-regular fa-circle-user"></i>
              </span>
              {author}
            </p> */}
            <p className="author_name">By - {author}</p>
            {/* <p className="course_time">
              <span className="time_icon">
                <i className="fa-regular fa-clock"></i>
              </span>
              {duration}days
            </p> */}
          <p className="course_time">Validity - {duration} days</p>
          </div>
          <p className="course_desc_home">
                    {(description).substring(0, 45)}...
                        <a href="/more-info" onClick={handleKnowMore}>Know More</a>
                    </p>
          {/* <h5 className="price">
            Starting From <span className="amount">₹ {price} /-</span>
          </h5> */}
          <div className="PriceSecStyle">
          <h5 className="price"><span className="amount">₹ {isActiveOffer ? offerPrice : price} /-</span></h5>
          {isActiveOffer ?
          <p className="offerPrice"><span className="offerAmount"><strike>₹ {price} /-</strike></span></p> : null}
          </div>
           
          {isActiveOffer ?
                    <div className="offerSecStyle">
                        {/* <p className="offerName"><i><b>{offerName}</b> Offer! </i> Valid upto {offerEndDate}</p> */}
                        <span className="offerName"><i><b>{offerName}</b> Offer! </i></span>
                        <span className="offerDuration">Valid upto {offerEndDate}</span>
                        {/* <p className="offerDuration">Valid upto {offerEndDate}</p> */}
                    </div> : null}
          <div className="course_card_footer">
          <div className="course_ftr">
            {/* <button className="subscribe_btn" onClick={() => handleSubscription()}>
              {existingFlag == true? 'Add to cart': 'Subscribe'}
            </button>
            <button className="knowmore_btn" onClick={() => handleKnowMore()}>
              Know More
            </button>
            <button className="knowmore_btn_view" onClick={() => handleKnowMoreView()}>
              Know More
            </button> */}
            <button className="subscribe_btn" onClick={() => courseType == 2 ? handleBuyNow() : handleSubscription()}>{existingFlag == true ? 'Add to cart' : courseType == 2 ? "Buy Now" : 'Individual'}</button>
                            {/* <button className="knowmore_btn" onClick={() => handleKnowMore()}>Know More</button> */}
                            <button className="knowmore_btn knowmore" onClick={() => handleTeamsRedirect()}>Teams</button>
          </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CourseItem;
